import { hashStringToSeed } from "../battle-enemy-level";

/** Mulberry32 — deterministic PRNG from a 32-bit seed. */
function mulberry32(seed: number): () => number {
	let t = seed >>> 0;
	return () => {
		t = (t + 0x6d2b79f5) >>> 0;
		let r = Math.imul(t ^ (t >>> 15), 1 | t);
		r ^= r + Math.imul(r ^ (r >>> 7), 61 | r);
		return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
	};
}

/**
 * Stable Fisher–Yates shuffle. Same seed + items → same order.
 * Does not mutate the input array.
 */
export function seededShuffle<T>(items: readonly T[], seed: string): T[] {
	const out = [...items];
	const random = mulberry32(hashStringToSeed(seed));
	for (let i = out.length - 1; i > 0; i -= 1) {
		const j = Math.floor(random() * (i + 1));
		const tmp = out[i];
		out[i] = out[j];
		out[j] = tmp;
	}
	return out;
}

/**
 * Permutation of indices `0..n-1` for the given seed.
 */
export function seededShuffleIndices(n: number, seed: string): number[] {
	if (n < 0) {
		throw new Error("seededShuffleIndices: n must be >= 0");
	}
	return seededShuffle(
		Array.from({ length: n }, (_, i) => i),
		seed,
	);
}
